export class ConstantsContainer {
    static apiVersion = "v1/"

    static hellopayBaseUrl =`${process.env.REACT_APP_HELLOPAY_BASE_URL}${ConstantsContainer.apiVersion}`

    static iveriPaymentBaseUrl = `${process.env.REACT_APP_IVERI_PAYMENT_BASE_URL}`

    static paymentTokenEndpoint = "payment-tokens"
    static csrfTokenEndpoint = "csrf-token"

    static iveriPaymentEndpoint = "transactions"

    static createPaymentEndpoint = "payments";

    static proxyUrl = "payment-tokens/iveri-token"

    static threeds_callback_url = `${process.env.REACT_APP_HELLOPAY_BASE_URL}${ConstantsContainer.apiVersion}3ds-authentication-callback`;
    static applicationid_3ds = `${process.env.REACT_APP_APPLICATION_ID}`;

    static payment_stage_authentication = "authentication";
    static payment_stage_authorisation = "authorisation";
}